import { useTypingPublisher } from "#/hooks/chat/useTypingPublisher";
import { useFileContext } from "#/hooks/FileContextWrapper";
import { useEffect } from "react";
import { FileUploadContextWrapper } from "../hooks/FileUploadContext";
import { useMessageContext } from "../hooks/MessageContext";
import { InteractiveChatBox } from "./chat/interactive-chat-box";
import { cn } from "./utls/utils";

function MainChatInput({
  groupChatId,

  typingPublisher,
}: {
  groupChatId?: string;

  typingPublisher?: { notifyTyping: () => void; stopTyping: () => void };
} = {}) {
  const {
    text,
    setText,
    sendMessage,
    chatType,
    groupChatId: contextGroupChatId,
  } = useMessageContext();
  const { isImageUploading } = useFileContext();
  const effectiveGroupChatId = groupChatId ?? contextGroupChatId ?? "";
  const pendingTypingPublisher = useTypingPublisher(effectiveGroupChatId);
  const { notifyTyping } = typingPublisher ?? pendingTypingPublisher;
  const isReadOnly = chatType === "all";

  const handleChangeText = (value: string) => {
    if (isReadOnly) {
      return;
    }
    setText(value);
    notifyTyping();
  };

  const handleSubmit = () => {
    if (isReadOnly) {
      return;
    }
    sendMessage();
  };

  useEffect(() => {
    if (isReadOnly && text) {
      setText("");
    }
  }, [isReadOnly, setText, text]);

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 bg-cream-200 shadow-lg shadow-beige-300/50 z-40">
      <div className="max-w-4xl mx-auto">
        <div
          className={cn(
            "flex items-end gap-1 w-full",

            "transition-colors duration-200",
            "hover:border-terracotta-400 focus-within:border-terracotta-500"
          )}
        >
          <FileUploadContextWrapper>
            <InteractiveChatBox
              onSubmit={handleSubmit}
              isDisabled={isImageUploading || isReadOnly}
              mode="submit"
              value={text}
              onChange={handleChangeText}
            />
          </FileUploadContextWrapper>
        </div>
      </div>
    </div>
  );
}

export default MainChatInput;
